<template>
  <v-container fluid>
    <v-layout class="mb-4">
      <v-flex xs6 md6>
        <h3 class="title font-weight-bold">Enterprises</h3>
      </v-flex>
      <v-flex xs6 md6 class="text-xs-right">
        <el-button @click="createDialog=true" type="danger" size="small">Create new</el-button>
      </v-flex>
    </v-layout>

    <template v-if="itemList.length>0">
      <el-table :data="itemList" style="width: 100%">
        <el-table-column label="ID" width="100">
          <template slot-scope="props">{{props.row.ent_id | numFormat('00000')}}</template>
        </el-table-column>
        <el-table-column label="Status" width="200">
          <template slot-scope="props">
            <div
              v-if="props.row.ent_status=='active'"
              class="green lighten-2 badge-status"
            >{{props.row.ent_status}}</div>
            <div
              v-if="props.row.ent_status!='active'"
              class="red lighten-2 badge-status"
            >{{props.row.ent_status}}</div>
          </template>
        </el-table-column>
        <el-table-column label="Name">
          <template slot-scope="props">{{props.row.ent_name}}</template>
        </el-table-column>
        <el-table-column label="Expried On" width="200">
          <template slot-scope="props">{{props.row.ent_expired| moment("DD/MM/YY HH:mm")}}</template>
        </el-table-column>
        <el-table-column label align="right" width="200">
          <template slot-scope="props">
            <el-button type="text" size="small" @click="viewItem(props.row)">View</el-button>
          </template>
        </el-table-column>
      </el-table>
    </template>
  </v-container>
</template>

<script>
import Service from "../../services";
export default {
  components: {},
  data() {
    return {
      createDialog: false,
      detailDrawer: false,
      selectedItem: null,
      itemList: []
    };
  },
  created() {
    Service.Enterprise.gets().then(res => {
      this.itemList = res.data;
    });
  },
  methods: {
    viewItem(item) {
      this.selectedItem = item;
      this.$router.push("/view/enterprise/" + this.selectedItem.ent_reference);
    }
  }
};
</script>